import { serviceOther } from "@/data/data";
import ServiceAreaCard from "./service-area-other-card";

const ServiceAreaOther = ({ title }: { title: string }) => {
    return (
        <>
            <section
                className="desilo-service6-section bg-color-2 section-padding-top-bottom overflow-hidden"
                id="service-section"
            >
                <div className="container custom-container">
                    <div className="row gx-4 gy-5">
                        <div className="col-12 col-xl-5 col-xxl-6">
                            <div className="desilo__header text-left text-lg-start">
                                <div>
                                    <h2 className="title">
                                        {title}
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 row-padding-top mt-0">
                            <div className="row g-4">
                                {/* service card start */}
                                {serviceOther.slice(0, 4).map((item, i) => (
                                    <ServiceAreaCard
                                        key={i}
                                        data={item}
                                    />
                                ))}
                                {/* service card end */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServiceAreaOther;
